import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

interface TransitionWrapperProps {
  children: React.ReactNode;
}

gsap.registerPlugin(useGSAP);

export const TransitionWrapper = ({ children }: TransitionWrapperProps) => {
  const location = useLocation();
  const containerRef = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      gsap.set(containerRef.current, { autoAlpha: 0, xPercent: -50 });
      gsap
        .timeline({
          paused: true,
        })
        .to(containerRef.current, {
          autoAlpha: 1,
          xPercent: 0,
          duration: 0.75,
          ease: "power1.inOut",
        })
        // .to(node, { duration: 0.5 })
        .play();
    },
    {
      dependencies: [location],
      scope: containerRef,
      revertOnUpdate: true,
    }
  );

  return (
    <div className=" w-full h-full flex overflow-scroll" ref={containerRef}>
      <div className="overflow-auto w-full">{children}</div>
    </div>
  );
};
